import StructuredEventProperty from './StructuredEventProperty';

export default class LinkClickEventProperty extends StructuredEventProperty {
  static override readonly type: number = 10;
  static override readonly label: string = 'LinkClick event property';
  static override readonly indexProps = [
    { index: 1, label: 'targetUrl' },
    { index: 2, label: 'elementId' },
    { index: 3, label: 'elementClasses' },
    { index: 4, label: 'elementTarget' },
    { index: 5, label: 'elementContent' },
  ];
}
